<template>

    <div class="msg">

    <div class="msg-avatar">
        <ChatAvatar :size="48" :role="assistantRole"></ChatAvatar>
    </div>

    <div class="msg-container">

        <div class="msg-header">
            <h2 class="sender-name">{{ senderName }}</h2>
        </div>

        <div class="msg-wrapper">

            <div class="msg-content">
                
                <div class="thinking-indicator">
                    <div class="dot left"></div>
                    <div class="dot center"></div>
                    <div class="dot right"></div>
                </div>

            </div>

        </div>

    </div>

    </div>

</template>

<script>
    import ChatAvatar from '@/components/chatavatar.vue';

    export default {
        name: 'ThinkingIndicator',
        components: {
            ChatAvatar,
        },
        computed: {
            assistantRole() {
                return this.$const.CHAT_MESSAGE_ROLE__ASSISTANT;
            },
            senderName() {
                return this.$t('CHATBOT_NAME');
            },
        }
    }
</script>

<style scoped>
.thinking-indicator {
    display: flex;
    padding: 0;
    background-color: #fff;
}

@media screen and (max-width: 600px) {
    .thinking-indicator {
        padding: 0;
    }
}
  
.thinking-indicator .dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #555;
    margin-right: 3px;
}

.thinking-indicator .dot.left {
    animation: 1.2s dot-animation ease-in-out .3s infinite;
}
.thinking-indicator .dot.center {
    animation: 1.2s dot-animation ease-in-out .6s infinite;
}
.thinking-indicator .dot.right {
    animation: 1.2s dot-animation ease-in-out .9s infinite;
}

@keyframes dot-animation {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.2;
    }
    100% {
        opacity: 1;
    }
}
</style>